import { Button, colors, FileUpload, IMInputText } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

export const TemplateSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2rem 3rem;
  border-top: 0.5rem solid ${colors.blue[300]};
  border-radius: 0 0 1rem 1rem;
  background-color: #f6f8fd;
  color: ${colors.neutral[900]};
`;

export const ToggleButtonStyled = styled(Button)`
  padding: 0;
  margin-bottom: 1rem;

  /* Typography */
  font-size: 2rem;
  line-height: 2.8rem;
  font-weight: 700;
  color: ${colors.neutral[900]};
`;

export const SubtitleStyled = styled.h3`
  margin: 0;

  /* Typography */
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 400;
  letter-spacing: 0.032rem;
  color: ${colors.neutral[700]};
  text-align: left;
`;

export const RadioButtonGroupStyled = styled.div<{ $isSectionOpen: boolean }>`
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: hidden;
  transition: max-height 0.3s, opacity 0.3s;
  will-change: max-height, opacity;
  opacity: ${({ $isSectionOpen }): CSSProp => ($isSectionOpen ? 1 : 0)};
  max-height: ${({ $isSectionOpen }): CSSProp => ($isSectionOpen ? '60rem' : 0)};
  margin-top: ${({ $isSectionOpen }): CSSProp => ($isSectionOpen ? '2rem' : 0)};
`;

export const IMInputTextStyled = styled(IMInputText)`
  width: auto;
  margin: 2rem 0;
`;

export const FileUploadStyled = styled(FileUpload)`
  margin-top: 3rem;
  background-color: ${colors.neutral.white};
`;
